export default __webpack_public_path__ + "static/media/honeywell.93e534d8.png";